<template>
  <div>
    <el-form
      class="mt-2"
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="mini"
      label-width="130px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_meetingTimeZone') || 'Time zone'"
          prop="meetingTimeZone"
        >
          <dict-select
            v-model="formData.meetingTimeZone"
            url="/master/common/dict/biz"
            :body="{ dictType: 'meetingTimeZone' }"
            :placeholder="$l('form_placeholder_meetingTimeZone')"
            size="mini"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_meetingDate') || 'Date'"
          prop="meetingDate"
          style="max-width: 60%"
        >
          <el-row :gutter="5">
            <el-col :span="10">
              <el-date-picker
                v-model="formData.meetingDate"
                type="date"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
                style="max-width: 100%"
                :placeholder="$l('form_placeholder_meetingDate')"
              />
            </el-col>
            <el-col :span="14">
              <TimeRangePicker
                :begin.sync="formData.meetingBeginTime"
                :end.sync="formData.meetingEndTime"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div class="el-form-row" v-if="meetingLocalTime">
        <el-form-item :label="$l('form_label_localTime') || 'Local Time'">
          <el-input :value="meetingLocalTime" readonly />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_custCode') || 'Customer'"
          prop="custCode"
        >
          <dict-select
            v-model="formData.custCode"
            url="/master/common/dict/customerSelectByStatus"
            :body="{ dictType: ['W', 'P', 'B', 'Y'] }"
            :placeholder="$l('form_placeholder_custCode')"
            :selectedLabel.sync="formData.custName"
            filterable
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_customerName') || 'Customer Name'"
          prop="customerName"
        >
          <el-input
            v-model="formData.customerName"
            :placeholder="$l('form_placeholder_customerName')"
            type="textarea"
            :rows="3"
            :maxlength="500"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_keyContact') || 'Key Contact'">
          <el-input
            v-model="formData.keyContact"
            :placeholder="$l('form_placeholder_keyContact')"
            type="textarea"
            :rows="3"
            :maxlength="200"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_meetingLocation') || 'Location'">
          <el-input
            v-model="formData.meetingLocation"
            :placeholder="$l('form_placeholder_meetingLocation')"
            :maxlength="100"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_meetingAddres') || 'Address'"
          style="width: 150%"
        >
          <el-input
            v-model="formData.meetingAddres"
            :placeholder="$l('form_placeholder_meetingAddres')"
            :maxlength="500"
            show-word-limit
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_purposeOrIssue') || 'Purpose or Issue'"
          prop="purposeOrIssue"
        >
          <el-input
            v-model="formData.purposeOrIssue"
            :placeholder="$l('form_placeholder_purposeOrIssue')"
            :maxlength="200"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_attendanceCodeList') || 'ABS attendance'"
          prop="attendanceCodeList"
        >
          <UserSelect
            :userCodes.sync="formData.attendanceCodeList"
            :userNames.sync="formData.attendanceNameList"
            :placeholder="$l('form_placeholder_attendanceCodeList')"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_merchandiserCodeList') || 'Merchandiser'"
        >
          <UserSelect
            :userCodes.sync="formData.merchandiserCodeList"
            :userNames.sync="formData.merchandiserNameList"
            :placeholder="$l('form_placeholder_merchandiserCodeList')"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_productCategories') || 'Product categories'"
        >
          <el-input
            v-model="formData.productCategories"
            :placeholder="$l('form_placeholder_productCategories')"
            :maxlength="200"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_meetingImportantLevel') || 'Important Level'"
        >
          <ImportantLevelRadio v-model="formData.meetingImportantLevel" />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_meetingTopics') || 'Meeting topics'"
        >
          <TopicsEditor v-model="formData.meetingTopics" :disabled="disabled" />
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ImportantLevelRadio from '../important-level-radio'
import UserSelect from '../user-select'
import TopicsEditor from '../topics-editor'
import TimeRangePicker from '../time-range-picker'
export default {
  mixins: [EditLoading],
  components: {
    UserSelect,
    ImportantLevelRadio,
    TopicsEditor,
    TimeRangePicker,
  },
  props: {
    disabled: { type: Boolean, default: false },
    expoMeetingCode: { type: String, default: '' },
    expoInfoCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { meetingImportantLevel: 'Medium' },
      backDialogVisible: false,
      rulesMap: {
        meetingTimeZone: {
          message: this.$l('rules_select_meetingTimeZone') || '请选择时区',
          validator(val) {
            const { meetingTimeZone } = val
            return !meetingTimeZone
          },
        },
        meetingDate: {
          message: this.$l('rules_select_meetingDate') || '请选择会议日期',
          validator(val) {
            const { meetingDate, meetingBeginTime, meetingEndTime } = val
            return !meetingDate || !meetingBeginTime || !meetingEndTime
          },
        },
        custCode: {
          message: this.$l('rules_select_custCode') || '请选择客户公司',
          validator(val) {
            const { custCode } = val
            return !custCode
          },
        },
        customerName: {
          message:
            this.$l('rules_input_customerName') || '请填写客户参会人',
          validator(val) {
            const { customerName } = val
            return !customerName
          },
        },
        purposeOrIssue: {
          message: this.$l('rules_input_purposeOrIssue') || '请填写会议标题',
          validator(val) {
            const { purposeOrIssue } = val
            return !purposeOrIssue
          },
        },
        attendanceCodeList: {
          message:
            this.$l('rules_select_attendanceCodeList') || '请选择会议负责人',
          validator(val) {
            const { attendanceCodeList } = val
            return (
              !attendanceCodeList ||
              !JSON.parse(attendanceCodeList || '[]')?.length
            )
          },
        },
      },
      rules: {
        meetingTimeZone: [{ trigger: 'change', required: true, message: ' ' }],
        meetingDate: [
          { trigger: 'change', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              const { meetingBeginTime, meetingEndTime } = this.formData
              if (!value || !meetingBeginTime || !meetingEndTime) {
                return callback(new Error(' '))
              }
              callback()
            },
          },
        ],
        custCode: [{ trigger: 'change', required: true, message: ' ' }],
        customerName: [{ trigger: 'blur', required: true, message: ' ' }],
        purposeOrIssue: [{ trigger: 'blur', required: true, message: ' ' }],
        attendanceCodeList: [
          { trigger: 'change', required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              if (!value || !JSON.parse(value || '[]')?.length)
                return callback(new Error(' '))
              callback()
            },
          },
        ],
      },
      localTimeZone: '',
    }
  },
  computed: {
    meetingLocalTime() {
      const {
        meetingLocalTimeZone,
        meetingLocalDate,
        meetingLocalBeginTime,
        meetingLocalEndTime,
      } = this.formData

      const meetingLocalTimeRange = [meetingLocalBeginTime, meetingLocalEndTime]
        .filter(Boolean)
        .join(' to ')
      return [meetingLocalTimeZone, meetingLocalDate, meetingLocalTimeRange]
        .filter(Boolean)
        .join(' ')
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.expoMeetingCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingDetailApi({
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.backDialogVisible = false
        const keys = Object.keys(this.rulesMap) || []
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          const res = this.rulesMap[key].validator(this.formData)
          if (res) {
            this.$message.warning(this.rulesMap[key].message)
            return
          }
        }
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoMeetingSaveApi({
          ...this.formData,
          expoInfoCode: this.expoInfoCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
          .el-range-input {
            width: 34%;
          }
          .el-range-separator {
            width: 11%;
            color: #606266;
          }

          .el-date-editor .el-input__inner {
            text-align: center;
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
